import {roles} from '../../authentication/constants';
import {HiddenSubmitButton, Select, TextInput, ValidationSummary} from '../../shared/components';
import {List, Map} from 'immutable';
import React, {PropTypes} from 'react';

const ROLE_OPTIONS = roles.ALL.map(role => ({value: role, label: role})).toArray();

export default function EditUserForm({loading, onFieldChange, onSubmit, saving, user, validationErrors}) {
  return (
    <form onSubmit={onSubmit}>
      <ValidationSummary errors={validationErrors} />
      <fieldset disabled={loading || saving}>
        <TextInput id="email" label="Email" onChange={onFieldChange} value={user.get('email')} />
        <Select id="roles" label="Roles" onChange={onFieldChange}
                multiple value={user.get('roles').toArray()} options={ROLE_OPTIONS} />
        <HiddenSubmitButton />
      </fieldset>
    </form>
  );
}

EditUserForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  user: PropTypes.instanceOf(Map).isRequired,
  validationErrors: PropTypes.instanceOf(List).isRequired
};



// WEBPACK FOOTER //
// ./app/features/users/components/EditUserForm.js